/* This file was generated by running "node scripts/generateTranslations.js". */
/* Created: 2026-09-10 13:57:07 */

const Keys = {
  '1_BEDS_COUNT': '1_BEDS_COUNT',
  '2_BEDS_COUNT': '2_BEDS_COUNT',
  '3_BEDS_COUNT': '3_BEDS_COUNT',
  '4_BEDS_COUNT': '4_BEDS_COUNT',
  '5_BEDS_COUNT': '5_BEDS_COUNT',
  '6_BEDS_COUNT': '6_BEDS_COUNT',
  '7_BEDS_COUNT': '7_BEDS_COUNT',
  '8_BEDS_COUNT': '8_BEDS_COUNT',
  '9_BEDS_COUNT': '9_BEDS_COUNT'
}; export default Keys;